module.exports = __webpack_public_path__ + "static/media/instagram-color.4962666b.svg";